import React from 'react'
import { PersonBlock } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'

export default function RelationshipPersonBlock({ person }) {
  const { t } = useTranslation()
  const lifespan = person?.living ? `${person.lifespan}${t('living', 'Living')}` : person?.lifespan

  return (
    <PersonBlock
      size="sm"
      avatarProps={{
        sex: person?.gender ? person.gender.toLowerCase() : null,
      }}
      name={person?.gender ? person.name : '-'}
      details={person ? `${lifespan} • ${person?.personId}` : '-'}
    />
  )
}
